import { Database } from 'lucide-react';
import { useWorkspaceStore } from '@/stores/workspace-store';
import { useGlobalSchemaStore } from '../global-schema-store';
import { connectionLabel } from './_schema-helpers';
import type { SearchItem, SearchProvider } from '../types';
import type { ConnectionConfig } from '@/types';

/**
 * All databases across every cached connection. Surfaces even the ones
 * the user hid via the visibility override, so search can still find
 * them — the hide-by-default is for the sidebar, not a hard filter.
 */
export const databaseSearchProvider: SearchProvider = {
  id: 'databases',
  kind: 'database',
  list: (ctx) => {
    const schemas = useGlobalSchemaStore.getState().schemas;
    const connections = ctx.queryClient?.getQueryData<ConnectionConfig[]>(['connections']) ?? [];
    const seen = new Set<string>();
    const items: SearchItem[] = [];

    for (const cache of schemas) {
      for (const db of cache.metadata.databases ?? []) {
        const key = `${cache.connectionId}:${db.name}`;
        if (seen.has(key)) continue;
        seen.add(key);
        const connName = connectionLabel(connections, cache.connectionId);
        items.push({
          id: `db:${cache.connectionId}:${db.name}`,
          kind: 'database',
          label: db.name,
          subtitle: `Database · ${connName}`,
          icon: Database,
          boost: 0.7,
          action: () => {
            useWorkspaceStore.getState().openTab({
              type: 'info',
              id: `info:${cache.connectionId}:${db.name}`,
              connectionId: cache.connectionId,
              database: db.name,
              objectType: 'database',
              objectName: db.name,
            });
          },
        });
      }
    }

    return items;
  },
};
